import React, { Component } from "react"
import styled from "@emotion/styled"
import { Date } from "prismic-reactjs"

const UpcomingEventsContainer = styled("div")`
  width: 100%;

  span {
    display: inline-block;
    border-top: 2px solid;
    margin-bottom: 24px;
    font-weight: 500;
    letter-spacing: 0.03em;
  }
  span.date {
    width: 95px;
    margin-right: 40px;
  }

  span.eventTitle {
    width: 490px;
    text-transform: uppercase;
  }

  h5 {
    font-weight: bold;
    margin-bottom: 16px;
  }

  @media (max-width: 1280px) {
    div.eventsWrapper {
      display: flex;
    }

    span.date {
      width: 30%;
      margin-right: 10px;
    }

    span.eventTitle {
      width: 70%;
    }
  }
`

class EventContainer extends Component {
  render() {
    return (
      <UpcomingEventsContainer>
        <h5>Upcoming Events</h5>

        {this.props.events.map((event, i) => {
          const date = Date(event.event_date)
          const formattedDate = Intl.DateTimeFormat("de-DE", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          }).format(date)

          return (
            <div className="eventsWrapper" key={i}>
              <span className="date">{formattedDate}</span>
              <span className="eventTitle">{event.event_title[0].text}</span>
            </div>
          )
        })}
      </UpcomingEventsContainer>
    )
  }
}

export default EventContainer
